import { InfoCircleFilled } from '@ant-design/icons';
import { Text } from '@components';
import { BORDER_COLORS } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import { Menu as BaseMenu } from 'antd';
import styled from 'styled-components';

export const Menu = styled(BaseMenu)<{ $position?: 'top' | 'bottom'; $collapsed: boolean }>`
    background: transparent;
    border: none !important;
    .ant-menu {
        max-width: 180px !important;
        padding: 0;
        margin: 0;
    }

    .ant-menu-item {
        ${({ $collapsed }) => ($collapsed ? '' : `padding: 11px 10px !important;`)}
        margin-bottom: 16px;
    }

    .ant-menu-item,
    .ant-menu-submenu {
        color: ${BORDER_COLORS.white};
        ${FONT_FAMILY.poppins}
        ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontSize}
        ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontWeight}
        ${DESKTOP_SIZES[SIZES.BODY_SM_MED].lineHeight}
    }

    .ant-menu-item:hover,
    .ant-menu-submenu:hover {
        ${({ $collapsed }) =>
            $collapsed ? 'background-color:transparent !important;' : `background-color: #409bdb !important;`}
    }

    .ant-menu-item-selected,
    .ant-menu-submenu-selected {
        ${({ $collapsed }) =>
            $collapsed ? 'background-color:transparent !important;' : `background-color: #409bdb !important;`}
    }

    .ant-menu-item-icon {
        width: 20px !important;
        height: 20px !important;
        min-width: 20px !important;
    }

    .ant-menu-item:hover,
    .ant-menu-submenu-title:hover {
        .ant-menu-submenu-expand-icon,
        .ant-menu-submenu-arrow,
        span[role='img'],
        a,
        .ant-menu-item-icon,
        .ant-menu-title-content {
            color: ${BORDER_COLORS.white};
        }
    }

    ${({ $position }) => $position === 'bottom' && `margin-top: auto;`}
`;

export const AboutVersionWrapper = styled.div`
    margin-left: auto;
`;

export const AboutVersionIcon = styled(InfoCircleFilled)`
    svg {
        width: 12px;
        height: 12px;
    }

    svg path {
        fill: var(--colors-grey-500, #50566e);
    }
`;

export const VersionWrapper = styled(Text)`
    color: #0d3e71;
`;
